export class BitHelper {


  public static isBitSet(numberValue: number, index: number): boolean {
    // eslint-disable-next-line no-bitwise
    const binaryString = (numberValue >>> 0).toString(2);
    return binaryString[binaryString.length - 1 - index] === '1';
  }
}
